import React from 'react'
import ReactApexChart from 'react-apexcharts'
import { COLOR, GRAPH_COLOR } from '@common/constants'

export default ({ dataSeries }) => {
    return (
        <ReactApexChart
            options={{
                ...defaultChartOption,
                chart: {
                    id: 'energy-chart', group: 'historical-page-chart', type: 'area',
                },
                grid: { padding: { left: 20 } },
                stroke: { width: 1.5, curve: 'stepline', },
                colors: [GRAPH_COLOR.ENERGY.TOTAL_ENERGY, GRAPH_COLOR.ENERGY.AVG_ENERGY],
                yaxis: tempYaxis,
                legend:
                {
                    position: 'top',
                    horizontalAlign: 'left',
                    offsetX: 20
                },
            }}
            series={dataSeries}
            height={180}
            type='area'
        />
    )
}

const defaultChartOption = {
    chart: {
        height: 350,
        animations: { enabled: true },
        autoScaleYaxis: true
    },
    dataLabels: {
        enabled: false
    },
    markers: { size: 0 },
    legend: {
        show: false,
        position: 'top',
        horizontalAlign: 'left',
        offsetX: 20
    },
    xaxis: {
        type: 'datetime',
        labels: {
            datetimeUTC: false,
            style: {
                colors: COLOR.DARKGREY,
            }
        }
    },
    tooltip: {
        x: {
            format: 'dd/MM/yy HH:mm',
        },
    },
    grid: {
        yaxis: {
            lines: {
                offsetX: -10,
                show: true
            },
        },
        xaxis: {
            lines: {
                show: true,
            },
            labels: {
                style: {
                    colors: COLOR.DARKGREY,
                },
                offsetY: 0,
                offsetX: 0,
                axisBorder: {
                    show: true,
                },
            },
        },
        padding: {
            left: 20,
            Right: 45
        },
        strokeDashArray: 5,
    },
}

const tempYaxis = {
    tickAmount: 1,
    axisBorder: {
        show: true
    },
    axisTicks: {
        show: true
    },
    labels: {
        style: {
            colors: COLOR.DARKGREY,
        },
    },
    title: {
        text: 'Energy (kwh)',
        style: { color: COLOR.TMD_GREY }
    }
}
